import { Locales } from '~/utils/constants/common';
import de from '~/utils/primevue-locales/de.json';
import en from '~/utils/primevue-locales/en.json';
import fr from '~/utils/primevue-locales/fr.json';
import it from '~/utils/primevue-locales/it.json';
import cs from '~/utils/primevue-locales/cs.json';

export function useLocale() {
  const primevue = usePrimeVue();

  const authStore = useAuthStore();

  const userStore = useUserStore();

  const primevueLocales = { de, en, fr, it, cs };

  const { setLocale: setCurrentLocale } = useI18n();

  const updateUserLanguage = async (locale: Locales) => {
    try {
      await userStore.updateUser({ requestBody: { language: locale } });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to update user language:', error);
    }
  };

  const setLocale = async (locale: Locales) => {
    primevue.config.locale = primevueLocales[locale];

    setCurrentLocale(locale);

    if (authStore.isLoggedIn) {
      await updateUserLanguage(locale);
    }
  };

  return { primevue, primevueLocales, updateUserLanguage, setLocale };
}
